module.exports = __webpack_public_path__ + "img/stick_hiver_ski_alpin.228ba283.svg";